import CountDown from '~/components/CountDown';
import { BigSaleLabel } from '~/domains/plusMembership/components/BigSale/BigSaleLabel';

interface Props {
  initialTime: number;
}

export function BigSalePromotionCountdown({ initialTime }: Props) {
  return (
    <div className="flex justify-center gap-x-8 rounded-lg bg-bigSale-background py-4">
      <BigSaleLabel />
      <p className="text-bigSale-text typo-paragraph100-semibold">
        <CountDown initialTime={initialTime} isDot /> 남음
      </p>
    </div>
  );
}
